import { useCallback, useEffect, useMemo, useState } from 'react'
import { Transition } from '@headlessui/react'
import { useGetBotMode } from 'hooks/useGetBotMode'
import { Icon } from 'components/ui/Icon'
import { ModalUploadManager, ModalUploadProps } from '../managers/modal/modal-upload-manager'

export const WidgetFileUploadModal = () => {
  const { isAppMode } = useGetBotMode()
  const [modalUploadProps, setModalUploadProps] = useState<ModalUploadProps>({})
  const { children, onClose } = modalUploadProps

  const showModal = useCallback((passedProps: ModalUploadProps) => {
    setModalUploadProps({ ...passedProps })
  }, [])

  const hideModal = useCallback(() => {
    setModalUploadProps({})
  }, [])

  const isVisible = useMemo(() => !!children, [children])

  useEffect(() => {
    ModalUploadManager.register({ showModal, hideModal })
  }, [])

  const onClickHideModal = () => {
    onClose?.()
    hideModal()
  }

  return (
    <Transition
      show={isVisible}
      enter="tw-transition-opacity tw-duration-400"
      enterFrom="tw-opacity-0"
      enterTo="tw-opacity-100"
      leave="tw-transition-opacity tw-duration-400"
      leaveFrom="tw-opacity-100"
      leaveTo="tw-opacity-0"
    >
      <div
        style={{
          width: '100%',
          backgroundColor: 'black',
          position: 'absolute',
          bottom: isAppMode ? '4rem' : '4rem',
          top: '7rem',
          zIndex: 999,
        }}
      >
        <div className={'tw-flex tw-flex-col tw-justify-between tw-h-full tw-p-3'}>
          <div className={'tw-flex tw-flex-row tw-justify-end w-full'}>
            <Icon
              icon={['far', 'times']}
              className="tw-cursor-pointer tw-h-4 tw-w-4 tw-stroke-[1.1px]"
              onClick={onClickHideModal}
            />
          </div>
          {children}
        </div>
      </div>
    </Transition>
  )
}
